module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.salesforce')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.salesforce'))), _c('span', {
    staticClass: "ambient"
  }, [_vm._v("( " + _vm._s(_vm.salesforceSandboxTeste) + " )")])])])])])]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.sendTo')))]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        return _vm.toggleSalesforceSendTo()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.salesforce_send_to
    }
  }), _c('label', [_vm._v(_vm._s(_vm.salesforce_send_to ? "Fila" : "Usuário responsável"))])])]), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.chooseData')) + ":")]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.sending_checked('lead')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.only_lead
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.onlyLead')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.sending_checked('lead_account')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.leads_and_accounts
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.leadAndAccounts')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.sending_checked('lead_account_opportunity')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.leads_accounts_and_opportunities
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.leadAccountsAndOpportunities')))])])])])])])]), _c('trigger-stages', {
    attrs: {
      "settings": _vm.salesforce_setting.triggers
    },
    on: {
      "selected-stages": _vm.setStages
    }
  }), _c('properties-matching', {
    attrs: {
      "properties_matching": _vm.salesforce_setting.properties_matching,
      "integration_name": "salesforce",
      "api_fields": _vm.api_fields
    },
    on: {
      "matching-updated": _vm.matchingUpdated
    }
  }), (!_vm.api_permissions) ? _c('div', {
    staticClass: "warning"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.$t(_vm.integrations.label.salesforce.featurePermission)) + " "), _c('a', {
    staticClass: "call-to-action-link",
    attrs: {
      "href": _vm.to_article,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.label.here')))]), _vm._v(".")])]) : _vm._e(), (!_vm.permission_groups && _vm.salesforce_send_to) ? _c('div', {
    staticClass: "warning"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.$t(_vm.integrations.label.salesforce.queuePermission)) + " "), _c('a', {
    staticClass: "call-to-action-link",
    attrs: {
      "href": _vm.to_article,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.label.here')))]), _vm._v(".")])]) : _vm._e(), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveSalesforceSetting
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
    staticClass: "pull-right btn btn-danger btn-nylas",
    on: {
      "click": _vm.redirectToSalesforceOauthUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/salesforce.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54a3715a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/salesforce.vue
// module id = 1124
// module chunks = 1